// Mowgi Communications - Mock Data

export const companyInfo = {
  name: "Mowgi Communications",
  tagline: "Marketing Built for Financial Investment Firms",
  description: "Mowgi Communications sits at the intersection of financial markets and strategic storytelling. We help investment firms translate complex ideas into clear, timely narratives that resonate with target audiences.",
  logo: "https://customer-assets.emergentagent.com/job_mowgi-revamp/artifacts/63kyiycm_cropped-High-resolution-Mowgi-logo-for-website-600x273-removebg-preview.png",
  foundedYear: 2022,
  location: "Singapore",
  address: "18 Robinson Rd, #15-00, Singapore 048547",
  email: "teams@mowgicommunications.com",
  linkedIn: "https://www.linkedin.com/in/nishtha-asthana",
};

export const heroSlides = [
    {
    title: 'Influence Across',
    subtitle: 'the Ecosystem',
    description: 'Amplifying your narrative through media, digital platforms and strategic industry partnerships.',
  },
  {
    title: 'Marketing Built for',
    subtitle: 'Financial Investment Firms',
    description: 'Theme driven organic marketing tailored for investment firms operating across the global financial ecosystem.',
  },
  {
    title: 'Market Aligned',
    subtitle: 'Strategy',
    description: 'Marketing aligned with what markets are talking about—now.',
  },
  {
    title: 'Credibility Led',
    subtitle: 'Content',
    description: 'Thought leadership designed for sophisticated investment audiences.',
  },

];

export const whyMowgi = {
  title: "Why MOWGI",
  headline: "Financial Markets Expertise Meets Impactful Storytelling",
  description: "Mowgi Communications sits at the intersection of financial markets and strategic storytelling. We help investment firms translate complex ideas into clear, timely narratives that resonate with target audiences. With deep roots in Asia's financial ecosystem, we turn insight into sustained influence, not short-term visibility.",
  subheadline: "What Sets MOWGI Apart",
  points: [
    "Deep understanding of financial markets and investment narratives",
    "Campaigns built around trending investment themes",
    "Strong media and ecosystem relationships",
    "Organic, credibility-led growth—not short-term noise",
  ],
  tagline: "Because Influence Is Built, Not Bought",
};

export const serviceBoxes = [
  { label: 'Content Marketing', icon: 'FileText' },
  { label: 'Social Media Marketing', icon: 'Share2' },
  { label: 'Brand Building', icon: 'Award' },
  { label: 'Marketing that translates into leads', icon: 'TrendingUp' },
];


export const PODCAST_API = "https://mowgicommunications.com/wordpress/wp-json/mo/v1/podcasts";
export const INSIGHT_API = "https://mowgicommunications.com/wordpress/wp-json/mo/v1/insights";
export const COMPANY_LOGO = "https://mowgicommunications.com/wordpress/wp-json/mo/v1/logo"
export const SUBSCRIBE_API = "https://mowgicommunications.com/wordpress/wp-json/mowgi/v1/subscribe"

export const services = [
  {
    id: 'brand-building',
    title: 'Narrative that Resonates',
    description: 'We sharpen your narrative, clarify your value proposition, and align messaging with market trends and investor expectations.',
    image: 'image 1.jpeg',
  },
  {
    id: 'brand-building',
    title: 'Campaigns That Move Mandates',
    description: 'We plan integrated campaigns around key market themes, align offerings, and optimise using real-time analytics.',
    image: 'image 2.jpeg', 
  },
  {
    id: 'thought-leadership',
    title: 'Authority Through Insights',
    description: 'We help publish research, explainers, executive commentary, and multimedia content that signals your authority and domain expertise.',
    image: 'Image 3.jpg', 
  },
  {
    id: 'thought-leadership',
    title: 'Influence and Visibility',
    description: 'We enable you to secure editorial coverage, shape stories, profile executives, and strategically place commentary where it matters.',
    image: 'Image 4.jpeg', 
  },
  {
    id: 'content-marketing',
    title: 'Evergreen Assets',
    description: 'We develop long-lived content for you—whitepapers, frameworks, case studies—that keeps your brand top-of-mind for decision-makers.',
    image: 'Image 5.jpeg', 
  },
  {
    id: 'social-media-marketing',
    title: 'Community That Engages',
    description: 'We work to grow relevant audiences on social media, and industry forums and foster engagement through conferences, roundtables, and knowledge hubs.',
    image: 'Image 6.jpeg', 
  },
  {
    id: 'thought-leadership',
    title: 'Expert and Peer Collaboration',
    description: 'We partner with analysts, industry veterans, and opinion leaders to extend reach, credibility.',
    image: 'Image 7.jpeg', 
  },
  {
    id: 'content-marketing',
    title: 'Bite sized content for the fast lane',
    description: 'We deliver concise, actionable insights via newsletters, explainers, and targeted learning series to build awareness and influence.',
    image: 'Image 8.jpeg', 
  },
  {
    id: 'digital-presence',
    title: 'Living Digital Presence',
    description: 'We deliver websites to reflect your actual offerings—an end-to-end, evolving digital presence that grows and adapts as your business and market strategy evolves.',
    image: 'Image 9.jpeg', 
  },
  {
    id: 'digital-presence',
    title: 'Discoverability',
    description: 'We ensure your content and website get discovered by the right audience through AI engine and search engine optimisation.',
    image: 'Image 10.jpeg', 
  },
];

export const clientLogos = [
  // 1 — AsianInvestor
  { 
    name: 'Asian Investor', 
    logo: 'logo 1.png' // AsianInvestor
  },

  // 2 — AsianInvestor Wealth
  { 
    name: 'Asian Investor Wealth', 
    logo: 'logo 2.png' // AsianInvestor Wealth
  },

  // 3 — FinanceAsia
  { 
    name: 'Finance Asia', 
    logo: 'logo 3.png' // FinanceAsia
  },

  // 4 — CorporateTreasurer
  { 
    name: 'Corporate Treasurer', 
    logo: 'logo 4.png' // CorporateTreasurer
  },

  // 5 — Lighthouse Canton
  { 
    name: 'Lighthouse Canton', 
    logo: 'logo 5.png' // Lighthouse Canton
  },

  // 6 — Vedas Group
  { 
    name: 'Vedas Group', 
    logo: 'logo 6.png' // Vedas Group
  },

  // 7 — Campden Wealth
  { 
    name: 'Campden Wealth', 
    logo: 'logo 7.png' // Campden Wealth
  },

  // 8 — Founders Forum Asia
  { 
    name: 'Founders Forum Asia', 
    logo: 'logo 8.png' // Founders Forum Asia
  },

  // 9 — Connect Group
  { 
    name: 'Connect Group', 
    logo: 'logo 9.png' // Connect Group
  },

  // 10 — Prestel & Partner
  { 
    name: 'Prestel & Partner', 
    logo: 'logo 10.png' // Prestel & Partner
  },

  // 11 — DC Finance
  { 
    name: 'DC Finance', 
    logo: 'logo 11.png' // DC Finance
  },

  // 12 — Campaign Asia
  { 
    name: 'Campaign Asia', 
    logo: 'logo 12.png' // Campaign Asia
  },

  // 13 — CII
  { 
    name: 'CII', 
    logo: 'logo 13.png' // CII
  },

  // 14 — The Digital Banker
  { 
    name: 'The Digital Banker', 
    logo: 'logo 14.png' // The Digital Banker
  },

  // 15 — DealStreetAsia
  { 
    name: 'DealStreetAsia', 
    logo: 'logo 15.png' // DealStreetAsia
  },

  // 16 — OANDA
  { 
    name: 'OANDA', 
    logo: 'logo 16.png' // OANDA
  },

  // 17 — OANDA Prop Trader
  { 
    name: 'OANDA Prop Trader', 
    logo: 'logo 17.png' // OANDA Prop Trader
  },
];
export const insights = [
  {
    id: 1,
    title: "India's private equity cycle steadies on later-stage IPOs",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80",
    link: "https://www.lighthouse-canton.com/insights/indias-private-equity-cycle-steadies-as-later-stage-deals-and-ipos-drive-recovery",
    date: "September 2025",
    category: "Private Equity",
  },
  {
    id: 2,
    title: "Tsao family office eyes rates, ESG and AI advances for portfolio construction",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    link: "https://www.asianinvestor.net/article/tsao-family-office-eyes-rates-esg-and-ai-advances-for-portfolio-construction/504498",
    date: "September 2025",
    category: "Family Office",
  },
  {
    id: 3,
    title: "How Dubai's maturing real estate market is attracting global capital",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&q=80",
    link: "#",
    date: "September 2025",
    category: "Real Estate",
  },
  {
    id: 4,
    title: "Toll Group bets on Asia's $1.5 trillion consumer surge",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80",
    link: "https://www.thecorporatetreasurer.com/article/toll-group-bets-on-asias-1-5-trillion-consumer-surge-as-supply-chains-reset/504563",
    date: "September 2025",
    category: "Supply Chain",
  },
  {
    id: 5,
    title: "OMERS outlines playbook for private and public market investing",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    link: "#",
    date: "September 2025",
    category: "Investment",
  },
  {
    id: 6,
    title: "Exceptionalism or exceptional opportunities?",
    image: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=800&q=80",
    link: "https://www.lighthouse-canton.com/insights/exceptionalism-or-exceptional-opportunities-investors-reassess-fundamentals-and-future-plays",
    date: "September 2025",
    category: "Markets",
  },
];

export const podcasts = [
  {
    id: 1, // unique podcast ID
    title: "Investing Insights: Navigating Public and Private Markets", // podcast title
    description: "Practical conversations on how to invest across public and private markets with industry experts.", // short summary
    youtubeId: "nJHPIypzNUU", // YouTube video ID
    category: "Investing Insights", // podcast category
    date: "August 2025", // publish date
  },
  {
    id: 2,
    title: "Expert Voices: Asset Management Strategies",
    description: "Interviews with asset managers, wealth managers, and industry leaders shaping financial strategies.",
    youtubeId: "xysjDjaOKhQ",
    category: "Expert Voices",
    date: "July 2025",
  },
  {
    id: 3,
    title: "Market Trends: Impact on Investment Decisions",
    description: "Analysis of the latest developments impacting investment decisions and opportunities.",
    youtubeId: "sME3ir7TOZI",
    category: "Market Trends",
    date: "June 2025",
  },
  {
    id: 4,
    title: "Brand Strategy for Finance",
    description: "Guidance on content, social media, and client engagement strategies for financial brands.",
    youtubeId: "PZKq1YsRvV8",
    category: "Brand Strategy",
    date: "May 2025",
  },
  {
    id: 5,
    title: "Brand Strategy for Finance",
    description: "Guidance on content, social media, and client engagement strategies for financial brands.",
    youtubeId: "TxfJxpaocHE",
    category: "Brand Strategy",
    date: "May 2025",
  },
  {
    id: 6,
    title: "Brand Strategy for Finance",
    description: "Guidance on content, social media, and client engagement strategies for financial brands.",
    youtubeId: "6zLBgsHMkzU",
    category: "Brand Strategy",
    date: "May 2025",
  },
  {
    id: 7, // new podcast ID
    title: "Expert Discussion: Financial Markets & Growth", // title for new video
    description: "An in-depth discussion on financial markets, long-term growth, and strategic insights.", // description
    youtubeId: "uSonpYrryxg", // extracted from the YouTube link
    category: "Expert Voices", // category (you can change this)
    date: "September 2025", // publish date (adjust if needed)
  },
];


export const podcastCategories = [
  "Investing Insights – Practical conversations on how to invest across public and private markets.",
  "Expert Voices – Interviews with asset managers, wealth managers, and industry leaders shaping financial strategies.",
  "Market Trends – Analysis of the latest developments impacting investment decisions and opportunities.",
  "Brand Strategy for Finance – Guidance on content, social media, and client engagement strategies for financial brands.",
];

export const founder = {
  name: "Nishtha Asthana",
  title: "Founder, Mowgi Communications",
  image: "https://customer-assets.emergentagent.com/job_mowgi-revamp/artifacts/pv6mk2up_1731595343133.jpeg",
  linkedIn: "https://www.linkedin.com/in/nishtha-asthana",
    experience: [
    "Digital Marketing Entrepreneur at Mowgi Marketing (Dec 2022 - Present)",
    "PR, Content, and Social Media Asia Lead for OANDA",
    "Asia Editor of CitiFX Wire at Citibank Singapore (7+ years)",
    "Treasury Sales at Citibank India serving major corporates",
  ],
  expertise: [
    "High-Impact Content & Social Media for Financial Brands",
    "Independent Writer for Top Publications",
    "MC and Event Host",
    "Sustainability Advocate with ESG expertise",
  ],
  education: [
    "MBA, Finance from IIT Madras (2003-2005)",
    "B.Tech, Information Technology from Indraprastha University Delhi (1999-2003)",
  ],

  shortBio: "Nishtha Asthana is the founder of Mowgi Communications. Mowgi partners with global asset allocators, asset managers, wealth managers, trading firms, and family offices to build high-trust brands and craft compelling, authoritative narratives.",
  
  fullBio: `Nishtha Asthana is the founder of Mowgi Communications. Mowgi partners with global asset allocators, asset managers, wealth managers, trading firms, and family offices to build high-trust brands and craft compelling, authoritative narratives.

Well connected with Asia's leading financial ecosystem through Mowgi, Nishtha is often invited to speak and moderate at exclusive closed-door events, investor roundtables, and industry forums, where she decodes market trends for institutional investors and business leaders.

Mowgi also contributes to leading regional media outlets, including AsianInvestor, FinanceAsia, AsianInvestor Wealth, and CorporateTreasurer, with Nishtha recognised as a valued voice on capital allocation trends, family office strategies, and institutional investment flows. She is one of Asia's few independent influencers at the intersection of capital markets, private wealth, corporate banking, and emerging investment themes across public and private markets.

Before founding Mowgi, Nishtha spent over 15 years at Citibank Capital Markets in India and Singapore, holding key roles in Sales & Trading, Product Development, and Markets Communications. Her institutional experience, combined with deep editorial insight and a background in deep tech startups, uniquely positioned her to launch Mowgi, bridging finance, media, and technology.

Mowgi's early success reflects Nishtha's expertise in navigating complex financial environments, producing authoritative content and strategic communications that resonate with evolving audiences. Leveraging digital technologies and AI-driven approaches, Mowgi empowers clients to unlock the full potential of their brands and succeed in today's dynamic business landscape.`,
};

export const successStories = [
  {
    title: "Visibility with UHNWIs",
    description: "Helped leading asset managers and family offices gain influence among ultra-high-net-worth individuals through tailored thought leadership campaigns.",
  },
  {
    title: "Strategic Deal Flow",
    description: "Enabled strategic partnerships and business opportunities by aligning client messaging with trending capital allocation and sustainability themes.",
  },
  {
    title: "Digital Leadership",
    description: "Built and scaled influential digital footprints for C-suite executives, driving measurable engagement, credibility, and brand trust across Asia.",
  },
];

export const teamHighlights = [
  {
    title: "Extensive Experience",
    description: "Our team's diverse backgrounds provide a wealth of knowledge and insights across finance, banking, and media.",
  },
  {
    title: "Driven by Technology",
    description: "We harness the power of modern technology to deliver agile and effective solutions.",
  },
  {
    title: "Trusted Partners",
    description: "Our lean model ensures we collaborate with the best industry partners and advisors for your success.",
  },
];

export const latestContent = [
  {
    id: 1,
    title: "India's private equity cycle steadies on later-stage IPOs",
    source: "Lighthouse Canton",
    link: "https://www.lighthouse-canton.com/insights/indias-private-equity-cycle-steadies-as-later-stage-deals-and-ipos-drive-recovery",
    date: "September 2025",
  },
  {
    id: 2,
    title: "Tsao family office eyes rates, ESG and AI advances",
    source: "Asian Investor",
    link: "https://www.asianinvestor.net/article/tsao-family-office-eyes-rates-esg-and-ai-advances-for-portfolio-construction/504498",
    date: "September 2025",
  },
  {
    id: 3,
    title: "Toll Group bets on Asia's $1.5 trillion consumer surge",
    source: "The Corporate Treasurer",
    link: "https://www.thecorporatetreasurer.com/article/toll-group-bets-on-asias-1-5-trillion-consumer-surge-as-supply-chains-reset/504563",
    date: "September 2025",
  },
  {
    id: 4,
    title: "Exceptionalism or exceptional opportunities?",
    source: "Lighthouse Canton",
    link: "https://www.lighthouse-canton.com/insights/exceptionalism-or-exceptional-opportunities-investors-reassess-fundamentals-and-future-plays",
    date: "September 2025",
  },
];

export const experienceSection = {
  title: "Our Experience",
  description: "Despite being a young enterprise, Mowgi Communications has quickly partnered with top-tier clients.",
};
